app.controller('studentExerciseBeginCtrl', [
    '$scope', '$interval', 'gameService', '$state', '$stateParams', 'stopwatchService', function ($scope, $interval, gameService, $state, $stateParams, stopwatchService) {
        var vm = this;

        vm.gameService = gameService;
        vm.exercise = gameService.exerciseWithIndex($stateParams.id);   

        vm.progressIndex = 0;
        vm.progressCount = 1 + vm.exercise.questions.length + 1 + vm.exercise.evaluationQuestions.length;
        vm.progressArray = new Array(vm.progressCount);

        vm.ebimageStyle = {
        	"background-image": "url(\"" + vm.exercise.imageUrl + "\")",
        	"background-size": "cover"
        };

        vm.next = function() {
            stopwatchService.start("exercise", vm.exercise.id);
            $state.go('student.exerciseperform', {id: $stateParams.id, question: 0});
        }
    }
]);
